<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <user-proxies-list
            ref="proxyList"
            :proxies="proxies"
            :total-count="totalCount"
            :edited="getUserProxiesAdmin"
            :loading="isLoading"
            :user-id="userId"
            :create-method="createUserProxy"
            :proxy-type="proxyType"
            :document-group="documentGroup"
            can-create
            can-edite
            enable-filters />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  import UserProxiesList from '@/components/reused/proxies/UserProxiesList.vue'
  import { PROXY_TYPES, IDENTITY_DOCUMENT_GROUPS } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { USER_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      UserProxiesList
    },
    props: {
      userId: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapState(USER_MANAGEMENT.NAMESPACE, {
        proxiesInfo: state => (state[USER_MANAGEMENT.STATE.PROXIES] || {})
      }),
      totalCount () {
        return this.proxiesInfo.totalCount || 0
      },
      proxies () {
        return this.proxiesInfo.items || []
      },
      headers () {
        return [
          { text: this.$t('Доверенность'), sortable: false, value: 'file.fileName' },
          { text: this.$t('Дата начала действия'), sortable: false, value: 'dateBegin' },
          { text: this.$t('Дата завершения действия'), sortable: false, value: 'dateEnd' },
          { text: this.$t('ФИО доверенного лица'), sortable: false, value: 'contactPerson' },
          { text: this.$t('Статус'), sortable: false, value: 'status' },
          { text: this.$t('Действия'), sortable: false, value: 'file.fileId' }
        ]
      },
      proxyType () {
        return PROXY_TYPES.USER_PROXY
      },
      documentGroup () {
        return IDENTITY_DOCUMENT_GROUPS.ORGANIZATION_AGENT_DOCUMENTS
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(USER_MANAGEMENT.NAMESPACE, {
        getUserProxiesAdminAction: USER_MANAGEMENT.ACTIONS.GET_USER_PROXIES_ADMIN,
        createProxyAdminAction: USER_MANAGEMENT.ACTIONS.CREATE_PROXY_ADMIN,
        clearUserProxiesAdminAction: USER_MANAGEMENT.ACTIONS.CLEAR_USER_PROXIES_ADMIN
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearUserProxiesAdminAction()
          ])
      },
      getUserProxiesAdmin: async function (params) {
        try {
          this.isLoading = true
          await this.getUserProxiesAdminAction({
            userId: this.userId,
            params
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      createUserProxy: async function (proxy) {
        try {
          this.isLoading = true

          await this.createProxyAdminAction({
            userId: this.userId,
            proxy
          })
          this.isLoading = false
          this.$refs.proxyList.getProxiesList()
        } catch (error) {
          this.isLoading = false
          throw error
        }
      }
    }
  }
</script>
